// extracted by mini-css-extract-plugin
export default {"favorite":"Favorite_favorite__s7FvX","notFavorite":"Favorite_notFavorite__XdXrm"};